export enum Roles {
  SUPPLIER = "supplier",
  MARKET_LEADER = "marketLeader",
}